import errorCodes from "../../errorCodes"

export default function medicalErrorHandler(code: string) {
  switch (code) {
    case errorCodes.PBMEDResourceNotFound:
      return "errors.PBMEDResourceNotFound"
    case errorCodes.PBMEDAlreadyOnboarded:
      return "errors.PBMEDAlreadyOnboarded"
    default:
      return ""
  }
}
